/**
 * SEO 配置 - chat (한국어)
 */

export default {
    chat: {
        title: 'AI 채팅 - 멀티모델 어시스턴트 | WeryAI',
        description:
            'WeryAI에서 최고의 AI 모델과 채팅하세요. 여러 창에서 응답을 나란히 비교하세요. 하나의 AI 워크스페이스에서 이미지, 동영상, 음악을 생성하세요.',
        keywords:
            'AI 채팅, AI 어시스턴트, 멀티모델 채팅, AI 챗봇, AI 모델 비교, 나란히 AI 채팅, GPT 대안, AI 워크스페이스, WeryAI',
        og_title: 'AI 채팅 - 멀티모델 어시스턴트 | WeryAI',
        og_description:
            '최고의 AI 모델과 채팅하고 응답을 나란히 비교하세요. 하나의 워크스페이스에서 이미지, 동영상 등을 생성. WeryAI에서 무료 체험.',
        twitter_title: 'AI 채팅 - 멀티모델 어시스턴트 | WeryAI',
        twitter_description:
            '최고의 AI 모델과 채팅하고 응답을 나란히 비교하세요. 하나의 워크스페이스에서 이미지, 동영상 등을 생성. WeryAI에서 무료 체험.',
    },
}
